export const environment = {
    production: false,
    apiUrl: 'https://hml.spiaapi.sigoscopasa.com.br/api/',
    env: 'dev'
};
